import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 25px 0px;
`
export const Padding = styled.div`
  padding: 5px 0px;
`
export const Ul = styled.ul`
  list-style-type: none;
  font-weight: 400;
  font-size: 18px;
  color: rgba(62, 62, 62, 1);
`
export const Li = styled.li`
  margin-bottom: 5px;
`

export const Title = styled.div`
  font-weight: 700;
  font-size: 64px;
  margin-left: 30px;
  padding-right: 20px;
  color: rgba(62, 62, 62, 1);
`

export const Text = styled.div`
  font-weight: 400;
  font-size: 18px;
  color: rgba(62, 62, 62, 1);
  margin-right: 160px;
  margin-left: 30px;
  margin-top: 20px;
  line-height: 27px;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const TextFooter = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: ${colors.blue};
`

export const PaddingText = styled.div`
  padding: '20px 20px 20px 20px';
`
export const ListTitle = styled.div`
  font-weight: 700;
  margin-bottom: 10px;
  margin-top: 80px;
`
export const ContainerBeneficios = styled.section`
  width: 100%;
  margin-right: 144px;
  margin-left: 14px;
  margin-top: 20px;
  line-height: 27px;
`
export const ContainerFooter = styled.section`
  width: 100%;
  margin-right: 144px;
  margin-left: 14px;
  margin-top: 20px;
  line-height: 27px;
`
